import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const B64ENCODED = /^data:image\/(?:bmp|jpeg|png|gif|tiff|svg\+xml);base64,.*/;

class Icon extends React.Component {
	render() {
		const { src, className } = this.props;

		if (src.match(B64ENCODED)) {
			return (
				<img
					src={src}
					alt=""
					className={className}
				/>
			);
		}

		return (
			<span className={cn(className, 'gg', src)} />
		);
	}
}

Icon.defaultProps = {
	src: 'icon-GG-code',
	className: null
};

Icon.propTypes = {
	/**
	 * The source of the icon.  The value can be a base64 encoded image data
	 * URL or one of the common set of icon names from axway-react-ui, e.g.
	 * `icon-GG-arrow`.  Defaults to `icon-GG-code`.
	 */
	src: PropTypes.string,
	/**
	 *
	 */
	className: PropTypes.string
};

export default Icon;
